import React, { Component } from 'react';
import ReactApexChart from "react-apexcharts";
import moment from 'moment';

class BasicColumnChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options: {
                chart: {
                    height: 350,
                    type: 'bar', // Changed from line to bar
                    toolbar: { show: false },
                },
                colors: ['#1DBF73'], // Set default color
                dataLabels: { enabled: false },
                yaxis: {
                    min: 0,
                    tickAmount: 4,
                    title: { text: props?.yAxis || 'Records Found' },
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                    labels: { style: { colors: '#000' } },
                },
                grid: {
                    borderColor: '#E9E9E9', // Set background grid lines color
                    strokeDashArray: 2, // Make grid lines subtle like the image
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                        borderRadius: 5,
                        columnWidth: "35%", // Adjusted for better spacing
                    },
                },
                xaxis: {
                    categories: props?.dates?.map((row) => moment(row).format('DD-MM-YYYY')),
                    axisBorder: { show: false },
                    axisTicks: { show: false },
                    labels: { style: { colors: '#000' } },
                }
            },
            series: [{
                name: props?.yAxis || 'Records Found',
                data: props?.ipArray || [],
            }]
        };
    }

    render() {
        return (
            <div>
                <ReactApexChart
                    options={this.state.options}
                    series={this.state.series}
                    type="bar" // Changed to bar chart
                    className="chart-class"
                    height="350px"
                />
            </div>
        );
    }
}

export default BasicColumnChart;
